var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.profiles.length > 1
    ? _c("div", [
        _c(
          "a",
          {
            staticClass:
              "btn clickable action-button board-selection-container btn-white dropdown-toggle btn-sm mr-2 bold applications-client-profile-controls w-100",
            attrs: {
              role: "button",
              "data-toggle": "dropdown",
              "data-boundary": "scrollParent",
              "data-flip": "true",
              "aria-haspopup": "true",
              "aria-expanded": "false",
            },
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("application.listing.viewOnBoard")) +
                "\n  "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "dropdown-menu",
            attrs: { "aria-labelledby": "dropdownMenuLinkBoard" },
          },
          _vm._l(_vm.profiles, function (ref) {
            var boardId = ref.boardId
            var boardName = ref.boardName
            var id = ref.id
            var statusLabelName = ref.statusLabelName
            return _c(
              "router-link",
              {
                key: id,
                staticClass:
                  "dropdown-item board-link text-truncate pl-4 mb-1 p-2 clickable",
                attrs: { to: _vm.getProfileLink(id, boardId) },
              },
              [
                _c("span", { staticClass: "bold" }, [
                  _vm._v("\n        " + _vm._s(boardName) + "\n      "),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("boards.messages.boardOwner")) +
                      ":\n        " +
                      _vm._s(_vm.getOwnerBoardName(boardId)) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.numberOfClients(boardId)) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                statusLabelName
                  ? _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("global.words.status")) +
                          ": " +
                          _vm._s(statusLabelName) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          1
        ),
      ])
    : _c(
        "router-link",
        {
          staticClass:
            "btn clickable btn-white action-button btn-sm bold w-100",
          attrs: {
            role: "button",
            to: _vm.getProfileLink(_vm.profiles[0].id, _vm.profiles[0].boardId),
          },
        },
        [
          _vm._v(
            "\n  " + _vm._s(_vm.$t("application.listing.viewOnBoard")) + "\n"
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }